import React, { useEffect } from "react";
import { connect } from "react-redux";
import PlaylistCard from "../../components/Playlistcard/Playlistcard";
import Searchusercard from "../../components/Searchusercard/Searchusercard";
import "./Searchresult.scss";
import { search } from "../../store/playList/actions";

const Searchresult = (props) => {
    const { searchedData, loading, loadedSearchData } = props.playlistDetail;
    useEffect(()=> {
        if(!loadedSearchData){
            props.search(props.location?.state?.searchData);
        }
    }, []);

    return(
        <div>
            {
                loading ? 
                (
                    <div>
                        Loading...
                    </div>
                ) :
                (
                    <div className="search-result-container">
                        {
                            !searchedData.length ? 
                            (
                                <div>
                                    No data regarding this search...
                                </div>
                            ) :
                            (
                                searchedData.map((data, indx) => {
                                    if(data.role) {
                                        return(
                                            <div key={indx} >
                                               <Searchusercard props={data}/>
                                            </div>
                                        )
                                    }else{
                                        return(
                                            <div key={indx}>
                                                <PlaylistCard props={data}/>
                                            </div>
                                        )
                                    }
                                })
                            )
                        }
                    </div>
                )
            }
        </div>
    )
}

const mapStateToProps = (state) => ({
    playlistDetail: state.playlist,
  });

export default connect(mapStateToProps, {
    search
})(Searchresult);